import { render, staticRenderFns } from "./EntityDetails.vue?vue&type=template&id=e3e2dffe"
import script from "./EntityDetails.js?vue&type=script&lang=js&external"
export * from "./EntityDetails.js?vue&type=script&lang=js&external"
import style0 from "./EntityDetails.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports